import axios from 'axios';
import { configHelper } from '@ilteducation/config';

export const getLastPosition = async (bookId: string, profileId?: string): Promise<string | undefined> => {
  const profileQueryParam = profileId ? `profileId=${profileId}` : '';
  try {
    const response = await axios.get(
      `${configHelper.getApiUrl('history-tracker')}/traces/book:${bookId}?${profileQueryParam}`,
    );

    const { data } = response; // TODO fix type for response
    return data.position || undefined; // Position can be string, empty string or null. This ensures it's an actual position or undefined.
  } catch {
    // 404 when trace is missing
    return undefined;
  }
};

export const createCFIWithTemporalOffset = (cfi: string, temporalOffset: number): string =>
  cfi.slice(0, -1).concat(`~${temporalOffset})`);
